import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "column items-center justify-center text-quote-text" }
const _hoisted_2 = { class: "q-mt-lg text-center" }
const _hoisted_3 = { class: "text-h2 q-mb-sm" }
const _hoisted_4 = { class: "text-body0 q-mb-sm" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "text-info text-bold"
}
const _hoisted_8 = {
  key: 0,
  class: "text-body0 q-mt-lg q-mb-sm"
}
const _hoisted_9 = { class: "text-weight-bold q-mt-lg q-mb-sm" }
const _hoisted_10 = ["innerHTML"]

import { useAuthStore } from "src/stores/authStore"
import { useConfigurationStore } from "src/stores/configurationStore"
import { MissingEntityDefinition } from "src/util/types/dataModels/entityDefinition"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxEmptyPageManager',
  props: {
  missingEntity: {
    required: true,
    type: Object as PropType<MissingEntityDefinition>,
  },

  allowHTML: {
    type: Boolean,
    default: false,
  },

  error: {
    type: Boolean,
    default: false,
  },

  iconColor: {
    type: String,
  },

  showWorkspace: {
    type: Boolean,
    default: false,
  },

  quoteTextSmall: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()
const authStore = useAuthStore()
const configurationStore = useConfigurationStore()

const currentWorkspaceName = computed(() => {
  return authStore.selectedWorkspace?.name || t("sfxEmpty.this_workspace")
})

const textColorClass = computed(() => {
  return {
    "text-error": props.error,
  }
})

const quoteClass = computed(() => (props.quoteTextSmall ? "text-body1" : "text-body0"))

const easterEggsEnabled = computed(() => configurationStore.easterEggs)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.missingEntity?.icon)
      ? (_openBlock(), _createBlock(_component_q_icon, {
          key: 0,
          name: props.missingEntity.icon,
          color: props.iconColor,
          class: "q-mb-sm",
          size: "120px"
        }, null, 8, ["name", "color"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(textColorClass.value)
        }, _toDisplayString(props.missingEntity.title), 3)
      ]),
      _createElementVNode("p", _hoisted_4, [
        (__props.allowHTML)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              innerHTML: props.missingEntity?.subtitle
            }, null, 8, _hoisted_5))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.missingEntity.subtitle), 1)),
        (props.showWorkspace)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(currentWorkspaceName.value), 1))
          : _createCommentVNode("", true)
      ]),
      (props.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("sfxEmpty.contact_administrator")), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("sfxEmpty.http_404")), 1)
          ]))
        : _createCommentVNode("", true),
      (easterEggsEnabled.value && props.missingEntity?.quote)
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: _normalizeClass(["text-italic q-mt-lg q-mb-sm", quoteClass.value]),
            innerHTML: props.missingEntity.quote
          }, null, 10, _hoisted_10))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})